import MaterialReactTable from "material-react-table";
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo, useState } from "react";
import { fetchProduit, updateProduit, fetchProduitAfc, produitChangerEtat } from "../../../Redux/produitReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import Configuration from "../../../configuration";
import { verification } from "../../../Redux/usersReduce";
import MyCarousel from "../../../components/Caroussel/MyCarousel";
import ExcelJS from 'exceljs';
// core components
function ListProduit({ obj, client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  document.title = t("Produit.list");
  const dispatch = useDispatch();
  const navigate = useHistory();
  var annee = localStorage.getItem("annee");
  const deviceType = "desktop";
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [idRole, setIdRole] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 25, 50, 100, { label: t("all"), value: entities.length }];


  // const getProduit = useCallback(async (titre) => {
  //   var produit = await dispatch(fetchProduit());
  //   setLoader(false)
  //   setEntities(produit.payload);
  // }, [dispatch]);

  const getProduit = useCallback(async (client) => {
    setLoader(true);
    try {
      await Promise.all([
        dispatch(fetchProduit({ client })).then((produit) => {
          setEntities(produit.payload);
        }),
        // You can add additional data fetching tasks here, e.g., fetching commandes
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch]);

  const getProduitAfc = useCallback(async (client) => {
    setLoader(true);
    try {
      await Promise.all([
        dispatch(fetchProduitAfc({ client })).then((produit) => {
          const filtered = produit.payload.filter((p) =>
            /\d$/.test(p.Code_article)  // garde uniquement ceux dont Code_article se termine par un chiffre
          );
          setEntities(filtered);
        }),
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch]);


  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };


  function changeEtat(id, e, client) {
    dispatch(produitChangerEtat(id)).then(e1 => {
      console.log(client)
      getProduitAfc(client);
      switch (e) {
        case 0: notify(1, "activé avec succés"); break;
        case 1: notify(1, "Désactivé avec succés"); break;
        default: break;
      }
    });
  }


  const updateListProduit = async () => {
    try {
      setLoader(true);

      const response = await dispatch(updateProduit({ client }));
      if (response.payload.msg === true) {
        notify(1, t("list_update"));
        if (idRole == 5 || idRole == 10 || idRole == 1) getProduitAfc(client);
        else getProduit(client);
      } else {
        notify(2, t("list_error"));
      }

    } catch (error) {
      console.error(error);
      notify(2, t("list_error"));
    } finally {
      setLoader(false);
    }
  };

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        } else {
          setIdRole(e.payload.id_role)
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  const columns = useMemo(() => [
    {
      accessorFn: (row) => row.image,
      id: 'image',
      header: t("image"),
      accessorKey: "image",
      Cell: ({ cell }) =>
        cell.row.original.image !== "" && cell.row.original.image != null ? (
          <img
            className="image-product"
            src={Configuration.BACK_BASEURL + "produit/" + cell.row.original.image}
            alt="Produit"
          />
        ) : null,
    },
    {
      accessorFn: (row) => row.Code_PCT,
      id: 'code_pct',
      header: t("code_pct"),
      accessorKey: "Code_PCT",
    },
    {
      accessorFn: (row) => row.Code_article,
      id: 'code_article',
      header: t("code_article"),
      accessorKey: "Code_article",
    },
    {
      accessorFn: (row) => row.Designation_1,
      id: 'designation',
      header: t("designation"),
      accessorKey: "Designation_1",
    },
    {
      id: 'prix',
      header: t("prix"),
      accessorFn: (row) =>
        row.Prix != null && row.Prix != 0
          ? new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          }).format(row.Prix)
          : "0.00",
    },

    {
      accessorFn: (row) => row.Coefficient_UC,
      id: 'cartonnage',
      header: t("cartonnage"),
      accessorKey: "Coefficient_UC",
    },
    {
      accessorFn: (row) => row.type,
      id: 'type',
      header: "Type",
      accessorKey: "type",
    },
    // {
    //   accessorFn: (row) => row.sites?.nom,
    //   id: 'Site',
    //   header: "Industrie",
    //   accessorKey: "sites.nom",
    // },
    {
      header: t("Actif portail"),
      accessorKey: "actif_portail",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">

          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(event) => {
              changeEtat(cell.row.original.id, cell.row.original.actif_portail, client);
            }}

            size="sm"
            className={cell.row.original.actif_portail === 1 ? "btn-success btn " : "btn-danger btn delete"}
          >
            <i className={cell.row.original.actif_portail === 1 ? "fa fa-check" : "fa fa-times"} id={"idLigne_" + cell.row.original.id} />
          </Button>
        </div>
      ),
    },
    {
      header: t("actions"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">

          <Button
            onClick={() => {
              navigate.push(client + "/produit/update/" + cell.row.original.id);
            }}
            variant="warning"
            size="sm"
            className="btn-warning btn "
          >
            <i className="fa fa-edit" />
          </Button>
        </div>
      ),
    },
  ], [client]);

  const [columnsGrossiste] = React.useState(
    [
      {
        accessorFn: (row) => row.image,
        id: 'image',
        header: t("image"),
        accessorKey: "image",
        Cell: ({ cell }) => (
          cell.row.original.image != "" && cell.row.original.image != null ? <img className="image-product" src={Configuration.BACK_BASEURL + "produit/" + cell.row.original.image}
          ></img> : null
        )
      },
      {
        accessorFn: (row) => row.Code_PCT,
        id: 'code_pct',
        header: t("code_pct"),
        accessorKey: "Code_PCT",
      },
      {
        accessorFn: (row) => row.Code_article,
        id: 'code_article',
        header: t("code_article"),
        accessorKey: "Code_article",
      },
      {
        accessorFn: (row) => row.Designation_1,
        id: 'designation',
        header: t("designation"),
        accessorKey: "Designation_1",
      },
      // {
      //   accessorFn: (row) => row.sites?.nom,
      //   id: 'Site',
      //   header: "Industrie",
      //   accessorKey: "sites.nom",
      // },
      {
        accessorFn: (row) =>
          new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.Prix),
        id: 'prix',
        header: t("prix"),
        accessorKey: "Prix",
      },

      {
        accessorFn: (row) => row.type,
        id: 'type',
        header: "Type",
        accessorKey: "type",
      },
    ]
  );
  function ListTable({ list, loader }) {
    return (
      <div>
        <MaterialReactTable
          columns={idRole == 1 || idRole == 10 || idRole == 5 ? columns : columnsGrossiste}
          state={{ isLoading: loader }}
          data={list}
          enableGlobalFilter={true}
          enableFilters={true}
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
            enableGlobalFilter: true,
            pagination: {
              pageSize: rowsPerPage,
            },

          }}
          filterFns={{
            myCustomFilterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
            },
          }}
          globalFilterFn="myCustomFilterFn"
          muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
          muiTablePaginationProps={{
            rowsPerPage: rowsPerPage,
            rowsPerPageOptions: rowsPerPageOptions,
            onRowsPerPageChange: handleRowsPerPageChange,
          }}
        />

      </div>
    );
  }


  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Define the columns based on your table structure
    worksheet.columns = [
      { header: t("code_pct"), key: 'Code_PCT' },
      { header: t("code_article"), key: 'Code_article' },
      { header: t("designation"), key: 'Designation_1' },
      { header: "Code EMG", key: 'Code_emg' },
      { header: t("prix"), key: 'Prix' },
      { header: t("cartonnage"), key: 'Coefficient_UC' },
      { header: "Actif", key: 'actif_portail' },
      { header: "Remise", key: 'remise' },
      { header: "Longueur", key: 'longueur' },
      { header: "Hauteur", key: 'hauteur' },
      { header: "Largeur", key: 'largeur' },
      { header: "Bu", key: 'bus' },
      { header: "BM", key: 'bms' },
      { header: "Brand", key: 'brands' },
      { header: "Specialite", key: 'specialites' },
      { header: "Type", key: 'type' },
      { header: "Nature", key: 'nature' },
      { header: "Promotion", key: 'promotions' },
      { header: "Tag", key: 'tag' },
    ];

    // Add rows to the worksheet
    entities.forEach(entity => {
      worksheet.addRow({
        Code_PCT: entity.Code_PCT,
        Code_emg: entity.Code_emg,
        Code_article: entity.Code_article,
        Designation_1: entity.Designation_1,
        Prix: entity.Prix,
        Coefficient_UC: entity.Coefficient_UC,
        actif_portail: entity.actif_portail,
        remise: entity.Remise == 1 ? "avec remise" : "sans remise",
        longueur: entity.longueur,
        hauteur: entity.hauteur,
        largeur: entity.largeur,
        bus: entity.bus?.nom,
        bms: entity.bms?.nom,
        brands: entity.brand,
        specialites: entity.specialite,
        promotions: entity.promotions?.nom,
        type: entity.type,
        nature: entity.nature
      });
    });

    // Write the Excel file to the browser
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'produit.xlsx';
      link.click();
    });
  };


  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole > 0) {
        if (obj.user.id_role == 6) getProduit(client);
        else getProduitAfc(client)
      }

    };
    fetchData();
  }, [getProduit, idRole]);

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <MyCarousel deviceType={deviceType} type={2} client={client} />
        <br></br><br></br>
        <Row>
          {idRole == 1 || idRole == 10 || idRole == 5 ? <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-right"
              type="button"
              onClick={updateListProduit}
            >
              <span className="btn-label">
                <i className="fas fa-sync-alt"></i>
              </span>
              {t("mise_produit")}
            </Button>
          </Col> : null}

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("Produit.list")} {idRole == 1 || idRole == 10 || idRole == 5 ? <Button
                  onClick={exportToExcel}
                  className=" btn-export export"
                >
                  Export Excel
                </Button> : null}
                </Card.Title>
              </Card.Header>
              <Card.Body className="padding-0 lineheight-2">


                <ListTable list={entities} loader={loader} ></ListTable>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListProduit;
